module.exports = __webpack_public_path__ + "img/fuwu.f0d3b00e.png";